module.exports = __webpack_public_path__ + "312811d902ec2403d7c23691d8f8a399.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/demand/banner-right-02.png
// module id = ./assets/images/demand/banner-right-02.png
// module chunks = 0